import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {PANE_MARGIN} from 'insights/InsightsConstants';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

/**
 * Contents of a loading `Pane`
 */
export default function LoadingPaneContents(): JSX.Element {
  return (
    <div className={css(styles.throbberMargin)}>
      <HorizontalThrobber />
    </div>
  );
}

const styles = StyleSheet.create({
  throbberMargin: {
    margin: PANE_MARGIN,
  },
});
